import { DataAnonymizationFormPresentation } from './data-anonymization-form.presentation';
import { DataAnonymizationFormVM } from './data-anonymization-form.viewmodel';
import { withViewModel } from '../../../infrastructure/components/with-view-model';

interface IProps {
    vm: DataAnonymizationFormVM;
}

const DataAnonymizationFormContainer = withViewModel(
    DataAnonymizationFormPresentation,
    (props: IProps) => {
        return props.vm;
    },
    () => []
);

export { DataAnonymizationFormContainer as DataAnonymizationForm };
